export const userKeys = {
  all: ["users"] as const,
  list: (params?: { page: number; size: number }) => [...userKeys.all, "list", params] as const,
};
